import React from 'react';

import { PageTitle } from '../../../components';
import { DonationForm } from '../../../sections';



const DonatePage = () => {

  return (

    <div className='donation-page'>

      {/* Page Title */}
      <PageTitle title={'Donate Now'} page={'Donate Now'} />

      {/* Donation Form */}
      <DonationForm />

    </div>
  );

}

export default DonatePage;